import * as React from 'react';
import { createSvgIcon } from '@mui/material';
var Catalog = createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  id: "Layer_1",
  viewBox: "0 0 48 48",
  x: "0px",
  y: "0px",
  version: "1.1"
}, /*#__PURE__*/React.createElement("g", {
  id: "catalog"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(2 4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy-15"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 9.8 9.8 H 0 V 0 h 9.8 V 9.8 Z M 0.5 9.3 h 8.8 V 0.5 H 0.5 V 9.3 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy-18"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 9.8 24.4 H 0 v -9.8 h 9.8 V 24.4 Z M 0.5 23.9 h 8.8 v -8.8 H 0.5 V 23.9 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy-20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 9.8 39.1 H 0 v -9.8 h 9.8 V 39.1 Z M 0.5 38.6 h 8.8 v -8.8 H 0.5 V 38.6 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy-17"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 44 9.8 H 14.7 V 0 H 44 V 9.8 Z M 15.2 9.3 h 28.3 V 0.5 H 15.2 V 9.3 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy-19"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 44 24.4 H 14.7 v -9.8 H 44 V 24.4 Z M 15.2 23.9 h 28.3 v -8.8 H 15.2 V 23.9 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy-21"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 44 39.1 H 14.7 v -9.8 H 44 V 39.1 Z M 15.2 38.6 h 28.3 v -8.8 H 15.2 V 38.6 Z"
}))))), 'Catalog');
export { Catalog };